import { ModalsKey } from '@/enums/modalsKey';
import { IconButton } from '@starsoft/common/components';
import useLayoutSettings from '@/hooks/theme/useLayoutSettings';
import { SettingLayoutComponentId } from '@starsoft/common/models';
import { useModalNavigation } from '@/hooks/modals/useModalNavigation';
import dynamic from 'next/dynamic';

const LanguageButtonV4 = dynamic(() => import('./Variants/V3'), { ssr: true });

export default function LanguageButton() {
  const { layoutVariant } = useLayoutSettings();
  const { navigateToModal } = useModalNavigation();

  function onClick() {
    navigateToModal(ModalsKey.Language);
  }

  switch (layoutVariant?.toString()) {
    case SettingLayoutComponentId.LayoutV1?.toString() ||
      SettingLayoutComponentId.LayoutV2?.toString():
      return (
        <IconButton onClick={onClick}>
          <i className="fad fa-globe-americas fa-swap-opacity" />
        </IconButton>
      );
    case SettingLayoutComponentId.LayoutV3?.toString():
      return (
        <IconButton onClick={onClick}>
          <i className="fad fa-globe-americas fa-swap-opacity" />
        </IconButton>
      );
    case SettingLayoutComponentId.LayoutV4?.toString():
      return <LanguageButtonV4 onClick={onClick} />;
    default:
      return (
        <IconButton onClick={onClick}>
          <i className="fad fa-globe-americas fa-swap-opacity" />
        </IconButton>
      );
  }
}
